const assignedRecord = {
  tableConfig: {
    // showCheckbox: true
  },
  queryList: [
  ],
  urlMap: {
    select: {
      url: '/exp/expReviewFlow/queryExpReviewFlowDTOPage',
      data: {
        reviewId: '{parentId}'
      }
    }
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'senderUnitName',
      label: '发送人单位'
    },
    {
      name: 'senderName',
      label: '发送人'
    },
    {
      name: 'senderMobile',
      label: '发送人电话'
    },
    {
      name: 'receiveType',
      label: '指派类型',
      map: {
        1: '专家',
        2: '接收单位'
      }
    },
    {
      name: 'receiveUnitName',
      label: '接收人单位'
    },
    {
      name: 'receiveName',
      label: '接收人'
    },
    {
      name: 'receiveMobile',
      label: '接收人电话'
    },
    {
      name: 'acceptStatus',
      label: '指派状态',
      map: {
        0: '未指派',
        1: '未送审',
        2: '待接收',
        3: '接收',
        4: '拒绝接收',
        5: '已评阅'
      }
    },
    {
      name: 'arrangeTime',
      label: '指派时间',
      width: '150'
    },
    {
      name: 'receiveTime',
      label: '接收时间',
      width: '150'
    }
  ]
}
export default assignedRecord



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/assignedRecord.js